import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, type RefObject } from 'react';
const LARGE_BREAKPOINT = 854 as const;
const SMALL_BREAKPOINT = 440 as const;
export const usePromoBannerSize = () => {
  const $ = _c(7);
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const observer = new ResizeObserver(entries => {
        globalThis.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || entries.length === 0) {
            return;
          }
          setWidth(entries[0].contentRect.width);
        });
      });
      if (ref.current != null) {
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const isLarge = width >= LARGE_BREAKPOINT;
  const isSmall = width > 0 && width <= SMALL_BREAKPOINT;
  const isMedium = width > SMALL_BREAKPOINT && width < LARGE_BREAKPOINT;
  let t2;
  if ($[2] !== isLarge || $[3] !== isMedium || $[4] !== isSmall || $[5] !== width) {
    t2 = {
      ref,
      isLarge,
      isMedium,
      isSmall,
      width
    };
    $[2] = isLarge;
    $[3] = isMedium;
    $[4] = isSmall;
    $[5] = width;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};